import type { Invoice } from '@/entities/invoices/invoice.entity';
import { CounterpartyType } from '@/entities/ledger/ledger-entry.entity';

type ResolveInvoiceCounterpartyTypeInput = Pick<
  Invoice,
  'counterpartyType' | 'customer' | 'booking'
>;

export function resolveInvoiceCounterpartyType(
  invoice: ResolveInvoiceCounterpartyTypeInput,
): CounterpartyType | null {
  if (invoice.counterpartyType) {
    return invoice.counterpartyType;
  }
  const booking = invoice.booking;
  if (!booking) {
    return null;
  }
  if (invoice.customer?.id && booking.agency?.id === invoice.customer.id) {
    return CounterpartyType.AGENCY;
  }
  if (
    invoice.customer?.id &&
    invoice.customer.id !== booking.customer?.id &&
    invoice.customer.id !== booking.agency?.id
  ) {
    return CounterpartyType.OTHER;
  }
  return CounterpartyType.CUSTOMER;
}
